<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/iImKcI/tc-custom/9781467765800.jpg?1705766126800" alt="This image is the cover for the book Why Are There Stripes on the American Flag?, Our American Symbols"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Why Are There Stripes on the American Flag?, Our American Symbols
      </h1>
      <p class="bookDescription body article font2">
        <p>Do you know why the US flag has stars and stripes on it? What does the flag stand for, and why do we say the Pledge of Allegiance? Join Mr. Gomez's class as they study the flag to find out! They'll learn when the first American flag was made, what the Pledge of Allegiance means, and why we still honor the flag today.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Martha E. H. Rustad, Kyle Poling
      </h2>
      
      <p class="authorDescription body article"><B>Martha E. H. Rustad</B> is the author of more than two hundred nonfiction children's books, on topics ranging from snowflakes to termites to the Statue of Liberty. She lives with her family in Brainerd, Minnesota.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Millbrook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6c1a0c6e